import React, { useState } from "react";
import { Card, CardHeader, Collapse, Container, Table } from "reactstrap";
import moment from "moment";

export const Documentos = ({ vam, documentos }) => {
    const [open, setOpen] = useState(false);

    const openCollapse = () => {
        setOpen(!open);
    };

    return (
        <div aria-multiselectable={true} className="card-collapse">
            <Card className="card-plain my-0">
                <CardHeader role="tab">
                    <div data-toggle="collapse" className="expanded c-pointer" onClick={openCollapse}>
                        {"Documentos"}&nbsp;&nbsp;
                        <i
                            className={
                                !open ? "now-ui-icons arrows-1_minimal-down" : "now-ui-icons arrows-1_minimal-up"
                            }
                        />
                    </div>
                </CardHeader>
                <Collapse isOpen={open}>
                    <Container className="text-center pl-0">
                        <div className={"table-responsive"}>
                            <Table className="adjusttd text-center">
                                <thead className="text-primary">
                                    <tr>
                                        {!vam && (
                                            <>
                                                <th className="text-left">Item</th>
                                                <th className="text-left">Documento</th>
                                                <th className="text-left">Recibe Broker</th>
                                                <th className="text-left" title={"Enviado a la Aseguradora"}>
                                                    Enviado Aseg.
                                                </th>
                                                <th className="text-left">Observaciones</th>
                                                <th className="text-left">Fecha Recordatorio</th>
                                            </>
                                        )}
                                        {vam && (
                                            <>
                                                <th className="text-left">Item</th>
                                                <th className="text-left" title={"Enviado a la Aseguradora"}>
                                                    Enviado Aseg.
                                                </th>
                                                <th className="text-left">Fecha Emi.</th>
                                                <th className="text-left">Documento</th>
                                                <th className="text-left">Observaciones</th>
                                                <th className="text-left">Solicitado a Cliente</th>
                                                <th className="text-left">Adicional</th>
                                            </>
                                        )}
                                    </tr>
                                </thead>
                                <tbody>
                                    {documentos.length === 0 ? (
                                        <React.Fragment>
                                            <tr>
                                                <td colSpan={8}>
                                                    <span>No hay información disponible.</span>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ) : (
                                        <React.Fragment>
                                            {documentos.map((item, index) => (
                                                <tr key={item.cdGastosVam}>
                                                    {!vam && (
                                                        <>
                                                            <td className="text-left">
                                                                <span>{index + 1}</span>
                                                            </td>
                                                            <td className="text-left">
                                                                <span>{item.nmDocumento}</span>
                                                            </td>
                                                            <td className="text-left">
                                                                <span>
                                                                    {" "}
                                                                    {item.fcReciboBrk
                                                                        ? moment(item.fcReciboBrk)
                                                                              .locale("moment/locale/es")
                                                                              .local()
                                                                              .format("DD/MMM/YYYY")
                                                                        : null}
                                                                </span>
                                                            </td>
                                                            <td className="text-left">
                                                                <span>
                                                                    {item.fcEnvioAseg
                                                                        ? moment(item.fcEnvioAseg)
                                                                              .locale("moment/locale/es")
                                                                              .local()
                                                                              .format("DD/MMM/YYYY")
                                                                        : null}
                                                                </span>
                                                            </td>
                                                            <td className="text-left">
                                                                <span>{item.obsDocSiniestro}</span>
                                                            </td>
                                                            <td className="text-left">
                                                                <span>
                                                                    {item.fcRecuerdaCli
                                                                        ? moment(item.fcRecuerdaCli)
                                                                              .locale("moment/locale/es")
                                                                              .local()
                                                                              .format("DD/MMM/YYYY")
                                                                        : null}
                                                                </span>
                                                            </td>
                                                        </>
                                                    )}
                                                    {vam && (
                                                        <>
                                                            <td className="text-left">
                                                                <span>{index + 1}</span>
                                                            </td>
                                                            <td className="text-center">
                                                                <span>{item.impreso ? "SI" : "NO"}</span>
                                                            </td>
                                                            <td className="text-center">
                                                                <span>
                                                                    {item.fcGasto
                                                                        ? moment(item.fcGasto)
                                                                              .locale("moment/locale/es")
                                                                              .local()
                                                                              .format("DD/MMM/YYYY")
                                                                        : null}
                                                                </span>
                                                            </td>
                                                            <td className="text-center">
                                                                <span>{item.detalle}</span>
                                                            </td>
                                                            <td className="text-justify">
                                                                <span>{item.obsGastoVam}</span>
                                                            </td>
                                                            <td className="text-center">
                                                                <span>{item.adicional ? "SI" : "NO"}</span>
                                                            </td>
                                                            <td className="text-center">
                                                                <span>{item.docAdic ? "SI" : "NO"}</span>
                                                            </td>
                                                        </>
                                                    )}
                                                </tr>
                                            ))}
                                        </React.Fragment>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </Container>
                </Collapse>
            </Card>
        </div>
    );
};
